export default function Eyebrow({ children, tone = "clay", className = "" }) {
  const color =
    tone === "clay" ? "text-clay" : tone === "sage" ? "text-sage" : "text-forest/60";
  return (
    <p
      className={`flex items-center gap-3 text-[0.7rem] font-semibold uppercase tracking-[0.2em] ${color} ${className}`}
    >
      <span className="inline-block h-[1.5px] w-8 bg-current" aria-hidden="true" />
      {children}
    </p>
  );
}
